import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-us-ui';

// Styled Components
//
// 1) STYLED COMPONENTS
//
// ${EmotionBreakpoint('tablet')} {
// ${EmotionBreakpoint('mobile')} {
const ContentBannerContainer = styled.div`
	width: 100%;
	height: 500px;

	${EmotionBreakpoint('mobile')} {
		width: 100%;
		height: auto;
		padding-bottom: 26px;
		.fox & {
			padding-bottom: 0px;
		}
		.law & {
			padding-bottom: 0px;
		}
		.osw & {
			padding-bottom: 0px;
		}
		.npr & {
			padding-bottom: 0px;
		}
	}

	.content-body-wrap {
		display: flex;
		flex-direction: ${(props) => (props.rowReverse ? 'row' : 'row-reverse')};
		text-align: left;
		height: 400px;
		background: ${(props) => props.bgColor || '#eaf4fb'};
		gap: 80px;
		padding-left: ${(props) => (props.rowReverse ? '0%' : '5%')};

		${EmotionBreakpoint('mobile')} {
			display: flex;
			flex-direction: column;
			align-items: center;
			height: auto;
			background-colour: #fff;
			gap: 0px;
			padding-left: 0%;
		}

		.content-image {
			align-self: self-start;
			height: auto;
			width: 598px;
			padding-left: ${(props) => (props.rowReverse ? '5%' : '0%')};
			padding-right: ${(props) => (props.rowReverse ? '0%' : '5%')};
			padding-top: 50px;
			display: flex;
			justify-content: ${(props) =>
				props.rowReverse ? 'flex-end' : 'flex-start'};
			flex: 1;

			${EmotionBreakpoint('mobile')} {
				width: 100%;
				align-self: auto;
				padding: 0px;
			}

			${EmotionBreakpoint('tablet')} {
				width: 100%;
				padding-left: 6%;
			}

			img {
				height: 400px;
				max-width: 100%;

				${EmotionBreakpoint('mobile')} {
					height: auto;
				}
				${EmotionBreakpoint('tablet')} {
					.fox & {
						height: 350px;
					}
				}
				@media (width: 1024px) {
					.fox & {
						height: 350px;
					}
				}
			}
		}

		.content-body {
			color: ${(props) => props.textColor || '#e83120'};
			width: 574px;
			margin: auto;
			flex: 1;
			padding-right: ${(props) => (props.rowReverse ? '5%' : '0%')};
			justify-items: ${(props) => (props.rowReverse ? 'start' : 'end')};

			${EmotionBreakpoint('tablet')} {
				width: 100%;
				padding-right: ${(props) => (props.rowReverse ? '6%' : '0%')};
			}

			${EmotionBreakpoint('mobile')} {
				width: 100%;
				margin: 0px;
				padding: 20px 5%;
				text-align: left;
				background: ${(props) => props.bgColor || '#eaf4fb'};
			}

			h3 {
				align-self: stretch;
				font-family: Escrow Banner Compressed;
				font-size: 40px;
				font-style: normal;
				font-weight: 500;
				line-height: 44px;
				margin-bottom: 12px;
				width: 574px;
				padding-right: ${(props) => (props.rowReverse ? '5%' : '0%')};

				.fox & {
					color: ${(props) => props.textColor || '#000'};
					font-family: Roboto;
					font-size: 30px;
					font-style: normal;
					font-weight: 500;
					line-height: 38px;
				}
				.bon & {
					color: ${(props) => props.textColor || '#000'};
					font-family: 'FuturaPT';
					font-size: 32px;
					font-style: normal;
					font-weight: 600;
					line-height: 40px; /* 125% */
					letter-spacing: 1.28px;
					text-transform: uppercase;
				}
				.law & {
					font-family: 'Oswald';
					text-transform: uppercase;
				}
				.osw & {
					font-family: 'Neue Aachen Pro';
				}
				.npr & {
					font-family: 'Gotham';
				}
				.wsj & {
					text-transform: uppercase;
				}

				${EmotionBreakpoint('tablet')} {
					width: 100%;
				}

				${EmotionBreakpoint('mobile')} {
					font-size: 32px;
					font-weight: 500;
					line-height: 32px;
					width: 100%;
					padding-right: 0px;
				}
			}

			p {
				align-self: stretch;
				font-family: Roboto;
				font-size: 16px;
				font-style: normal;
				font-weight: 400;
				line-height: 24px;
				width: 574px;
				white-space: pre-line;
				padding-right: ${(props) => (props.rowReverse ? '5%' : '0%')};
				.fox & {
					color: ${(props) => props.textColor || '#000'};
					font-family: Roboto;
					font-size: 16px;
					font-style: normal;
					font-weight: 400;
					line-height: 140%;
				}
				.bon & {
					color: ${(props) => props.textColor || '#000'};
					font-family: 'FuturaPT';
					font-size: 16px;
					font-style: normal;
					font-weight: 400;
					line-height: 20px;
				}

				${EmotionBreakpoint('tablet')} {
					width: 100%;
					margin: 0 auto;
				}
				${EmotionBreakpoint('mobile')} {
					width: 100%;
					padding-right: 0px;
				}
			}
		}
	}
`;

// Component
const ContentBannerSection = ({ contentfulData }) => {
	const {
		contentBannerImage,
		contentBannerImagePlacement,
		contentBannerHeadline,
		contentBannerBody,
		contentBannerBackgroundColor,
		contentBannerTextColor,
	} = contentfulData || {};

	return (
		<ContentBannerContainer
			className='lp-contentbanner'
			bgColor={contentBannerBackgroundColor?.value}
			textColor={contentBannerTextColor?.value}
			rowReverse={contentBannerImagePlacement}
		>
			<div className='content-body-wrap'>
				<div className='content-image'>
					{/* Image */}
					{contentBannerImage?.fields?.file?.url && (
						<img
							src={`https:${contentBannerImage?.fields.file.url}`}
							alt={'Content banner image'}
						/>
					)}
				</div>
				<div className='content-body'>
					<h3>{contentBannerHeadline}</h3>
					<p>{contentBannerBody}</p>
				</div>
			</div>
		</ContentBannerContainer>
	);
};

export { ContentBannerSection };
